// highcharts/highcharts-more が必要なChart用
import Highcharts from 'highcharts';
import HighchartsMore from 'highcharts/highcharts-more';
import Chart from './Chart';

HighchartsMore(Highcharts); // eslint-disable-line new-cap

export default class ChartMore extends Chart {
  render() {
    return super.render();
  }
}



// WEBPACK FOOTER //
// ./es6/utils/components/ChartMore.js